import React from 'react';
import { Helmet } from 'react-helmet';
import './styles.css';
import Footer from '../../components/Footer';
import Header from '../../components/Header';

const AppLayout = props => {
  const { user, children } = props;
  return (
    <div className="app">
      <Helmet titleTemplate="%s | GoBuyside" defaultTitle="GoBuyside">
        <meta
          name="description"
          content="GoBuyside is the leading recruitment and networking platform for private equity firms, hedge funds, investment banks and consulting firms."
        />
      </Helmet>
      <Header user={user} />
      <div className="app__content">{children}</div>
      <Footer user={user} />
    </div>
  );
};

export default AppLayout;
